import { styled } from '@mui/material/styles';

import { Theme, px, rem } from '../../theme';
import { Paragraph } from '../Paragraph';

export const StyledContent = styled('div')`
    flex-direction: column;
    justify-content: flex-start;
    padding: ${({ theme }: { theme: Theme }) =>
        theme.tggSpacing(rem(0.625), 1.5625)};
    text-align: left;
`;

export const StyledDescription = styled(Paragraph)`
    ${({ theme }: { theme: Theme }) => `
        padding-top: ${theme.tggSpacing(rem(0.625), 1.5625)};
        padding-bottom: ${theme.tggSpacing(rem(0.625), 1.5625)};

    ${theme.breakpoints.up('desktop')} {
        padding-top: ${theme.tggSpacing(rem(1.25), 3.125)};
        padding-bottom: ${theme.tggSpacing(px(30), 7.5)};
    }
	`}
`;

export const StyledAddOnTileItem = styled('div')`
    display: flex;
    align-items: center;
    justify-content: space-between;

    & > span {
        display: flex;
    }
`;

export const StyledPrice = styled('div')`
    align-self: center;
    margin-right: ${({ theme }: { theme: Theme }) =>
        theme.tggSpacing(rem(0.5), 1.25)};
    ${({ theme }: { theme: Theme }) =>
        theme.typography.text_15_bold_lh_21_desktop_17};
    color: ${({ theme }: { theme: Theme }) => theme.palette.primary.main};
`;

export const StyledDiscountedPrice = styled('span')`
    text-decoration: line-through;
`;

export const StyledDuration = styled('span')`
    ${({ theme }: { theme: Theme }) =>
        theme.typography.text_15_lh_24_desktop_18_lh_26};
    color: ${({ theme }: { theme: Theme }) => theme.palette.common.blue};
`;

export const StyledDiscountMessage = styled('div')`
    ${({ theme }: { theme: Theme }) => theme.typography.heading_10_lh_16};

    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        ${({ theme }: { theme: Theme }) => theme.typography.text_12_lh_18}
    }
`;

export const StyledPriceContainer = styled('div')`
    display: flex;
    flex-direction: column;
`;
